import { render, staticRenderFns } from "./ExamDialog.vue?vue&type=template&id=3d842d14&scoped=true&"
import script from "./ExamDialog.vue?vue&type=script&lang=js&"
export * from "./ExamDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExamDialog.vue?vue&type=style&index=0&id=3d842d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d842d14",
  null
  
)

component.options.__file = "ExamDialog.vue"
export default component.exports